import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetOneSU_NT_MRI_MainResearcherInformain = createAsyncThunk(
  "SU_NT_MRI_MainResearcherInformain/GetOneSU_NT_MRI_MainResearcherInformain",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SU_NT_MRI_MainResearcherInformain/GetOneSU_NT_MRI_MainResearcherInformain",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateMainResarcherPage = createAsyncThunk(
  "SU_NT_MRI_ApplicationInformationModel/UpdateMainResarcherPage",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SU_NT_MRI_ApplicationInformationModel/UpdateMainResarcherPage",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ValidateMainResearcherPage = createAsyncThunk(
  "SU_NT_MRI_ApplicationInformationModel/ValidateMainResearcherPage",
  async (applicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SU_NT_MRI_ApplicationInformationModel/ValidateMainResearcherPage",
        { applicationInformationId: applicationInformationId }
      );

      const data = response.data.result; // Assuming response has a "data" field
      if (response.data.success === true) {
        const arrayValidate = response.data.result.map((ele, ind) => {
          return ele.code;
        });
        return arrayValidate; // Return the extracted data
      }
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const MainResearcherInformation = createSlice({
  name: "MainResearcherInformation",
  initialState: {
    MainResearcherInformain: {},
    loadingMainResearcherInformain: false,
    errorMainResearcherInformain: null,

    //---------------UpdateMainResarcherPage----------------------
    UpdateMainResearcherInformain: {},
    loadingUpdateMainResearcherInformain: false,
    errorUpdateMainResearcherInformain: null,

    //---------------ValidateMainResearcherPage----------------------
    ValidateMainResearcherPageList: [],
    loadingValidateMainResearcherPageList: false,
    errorValidateMainResearcherPageList: null,
  },
  reducers: {
    setMainResearcherInformain: (state, action) => {
      state.MainResearcherInformain = action.payload;
    },
    setValidateMainResearcherPageList: (state, action) => {
      state.ValidateMainResearcherPageList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        GetOneSU_NT_MRI_MainResearcherInformain.pending,
        (state, action) => {
          state.loadingMainResearcherInformain = true;
          state.MainResearcherInformain = action.payload;
          state.errorMainResearcherInformain = null;
        }
      )
      .addCase(
        GetOneSU_NT_MRI_MainResearcherInformain.fulfilled,
        (state, action) => {
          state.loadingMainResearcherInformain = false;
          state.MainResearcherInformain = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetOneSU_NT_MRI_MainResearcherInformain.rejected,
        (state, action) => {
          state.loadingMainResearcherInformain = false;
          state.MainResearcherInformain = action.payload;
        }
      )
      //------------------------------UpdateMainResarcherPage------------------------
      .addCase(UpdateMainResarcherPage.pending, (state, action) => {
        state.loadingUpdateMainResearcherInformain = true;
        state.UpdateMainResearcherInformain = action.payload;
        state.errorUpdateMainResearcherInformain = null;
      })
      .addCase(UpdateMainResarcherPage.fulfilled, (state, action) => {
        state.loadingUpdateMainResearcherInformain = false;
        state.UpdateMainResearcherInformain = action.payload; // Assuming payload has the desired data
      })
      .addCase(UpdateMainResarcherPage.rejected, (state, action) => {
        state.loadingUpdateMainResearcherInformain = false;
        state.UpdateMainResearcherInformain = action.payload;
      })
      //------------------------------ValidateMainResearcherPage------------------------
      .addCase(ValidateMainResearcherPage.pending, (state, action) => {
        state.loadingValidateMainResearcherPageList = true;
        state.ValidateMainResearcherPageList = action.payload;
        state.errorValidateMainResearcherPageList = null;
      })
      .addCase(ValidateMainResearcherPage.fulfilled, (state, action) => {
        state.loadingValidateMainResearcherPageList = false;
        state.ValidateMainResearcherPageList = action.payload; // Assuming payload has the desired data
      })
      .addCase(ValidateMainResearcherPage.rejected, (state, action) => {
        state.loadingValidateMainResearcherPageList = false;
        state.ValidateMainResearcherPageList = action.payload;
      });
  },
});
export const { setMainResearcherInformain,setValidateMainResearcherPageList } = MainResearcherInformation.actions;
export default MainResearcherInformation.reducer;
